/**********************************************************
Chemical Application Display: Displays data for viewing & prior to submission

**********************************************************/
import SolutionsTable from './chem_app_solution_table';
import SolsTable from './chem_app_sol_table';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  application: PropTypes.object,
  chemicalList: PropTypes.array,
  solutions: PropTypes.array,
  view: PropTypes.bool
};

const ChemicalApplicationDisplay = ({ chemicalList, solutions, application, employees,
  selectedApp, view, createOrEdit, toDelete }) => {
  const { certId, fieldId, round, employee } = application;

  let previousApplications = [];
  if (selectedApp) previousApplications = selectedApp.previousApplications;
  let emp = {};
  let name = 'N/A';
  if (employees.length > 0 && employee !== undefined) {
    emp = employees.find((e) => e.eid === employee);
    if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
  }

  return (
    <div>
      { toDelete ? <h2 className="red-text chem-app-flex">Are you sure you want to delete the following log?</h2> : '' }
        <div>
          <span className="right"><i className="material-icons red-text medium">bug_report</i></span>
          <span className="app-log-header">Application Log</span>
        </div>
        <br />
        <hr />
      {
        previousApplications.length > 0 ?
          <div className="row">
            <h5 className="blue-text app-log-prev-header">Previous Applications - { fieldId }, Round { round }</h5>
            <table className="bordered highlight responsive-table centered chem-app-table">
              <thead>
                <tr className="chem-app-table-headers">
                  <th>Date</th>
                  <th>Field</th>
                  <th>Employee</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Hours</th>
                  <th>Acres Completed</th>
                  <th>Acres Balance</th>
                  <th>Status</th>
                  <th>Products</th>
                  <th>Round</th>
                  <th>REI</th>
                  <th>Pre-Harvest</th>
                </tr>
              </thead>
              <tbody>
              {
                previousApplications.map((s, i) => {
                  let chems = s.solutions.map((sols) => sols.chemId);
                  let c = [];
                  c = chems.map((chemId) => { return chemId === '' ? '' : chemicalList.find((cl) => cl.id === Number(chemId)) });
                  if (c === undefined || c[0] === undefined) c = [];
                  let name = 'N/A';
                  let emp = {};
                  if (employees.length > 0 && s.employee !== undefined) {
                    emp = employees.find((e) => e.eid === s.employee);
                    if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
                  }
                  return (
                    <tr className="chem-app-table-row" key={s.id}>
                      <td>{ moment(s.date).format('MM/DD/YYYY') }</td>
                      <td>{ s.fieldId }</td>
                      <td>{ name }</td>
                      <td>{ s.startTime }</td>
                      <td>{ s.endTime }</td>
                      <td>{ s.hours }</td>
                      <td>{ s.acresCompleted }</td>
                      <td>{ s.acresBalance < 0 ? <span className="red-text">{ s.acresBalance }</span> : <span>{ s.acresBalance }</span> }</td>
                      <td>
                         { s.isComplete === 0 || s.isComplete === '0' ? <span className="label label-incomplete">Incomplete</span>
                            : <span className="label label-complete">Complete</span>
                         }
                      </td>
                      <td>{ c.length > 0 ? c.map((chem) => (<span className="chem-app-table-name" key={chem.id}>{ chem.name }<br /></span>)) : '' }</td>
                      <td>{ s.round }</td>
                      <td>{ s.reiDaysRemaining } days</td>
                      <td>{ s.preHarvestDaysRemaining } days</td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
        : ''
      }
      <div className="row">
        <div className="col s12">
          <h5 className="blue-text app-log-prev-header">Application</h5>
          <span className="certId">#{ certId }</span>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Date</strong>
          <p>{ moment(application.date).format("dddd, MMMM Do YYYY") }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Employee</strong>
          <p>{ employees.length > 0 && employee !== undefined ? <span>{ name }</span> : 'N/A' }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Field</strong>
          <p>{ application.fieldId }</p>
        </div>
        <div className="col s6 m3 l3 xl3">
          <strong>Method</strong>
          <p>{ application.method }</p>
        </div>
        <div className="col s12">
          <hr />
          <table>
            <thead>
              <tr>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Hours</th>
                <th>Acres Completed</th>
                <th>Acres Balance</th>
                <th>Status</th>
                <th>Round</th>
                <th>REI</th>
                <th>Pre-Harvest</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={'chem-app-time'}>{ application.startTime }</td>
                <td>{ application.endTime }</td>
                <td>{ application.hours }</td>
                <td>{ application.acresCompleted }</td>
                <td>{ application.acresBalance < 0 ? <span className="red-text">{ application.acresBalance }</span> : <span>{ application.acresBalance }</span> }</td>
                <td>
                   { application.isComplete === 0 || application.isComplete === '0' ? <span className="label label-incomplete">Incomplete</span>
                      : <span className="label label-complete">Complete</span>
                   }
                </td>
                <td>{ application.round }</td>
                <td>{ application.reiDaysRemaining } days</td>
                <td>{ application.preHarvestDaysRemaining } days</td>
              </tr>
            </tbody>
          </table>
          <br />
          <div className="divider"></div>
          <div className="section chem-app-flex">
            <span><b>Total Gallons: </b>{ application.measurement }</span>
            <span><b>Notes: </b>{ application.notes }</span>
          </div>
          {
            solutions.length > 0 ?
              <div className="row">
                <h5 className="blue-text app-log-prev-header">Products</h5>
                <div className="col s1"></div>
                <div className="col s10">
                  { /* SolutionsTable uses different array of object */
                    createOrEdit ? <SolutionsTable solutions={solutions} chemicalList={chemicalList} readOnly />
                    : <SolsTable solutions={solutions} chemicalList={chemicalList} />
                  }
                </div>
                <div className="col s1"></div>
              </div>
            : ''
          }
        </div>
      </div>
      <div className="divider"></div>

    </div>
  );
}


ChemicalApplicationDisplay.propTypes = propTypes;
export default ChemicalApplicationDisplay;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_display.js